import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type EmbeddingsNodeType = Node<NodeData, 'custom_embeddings'>;

export const EmbeddingsNode: React.FC<NodeProps<EmbeddingsNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const inputPort = (data.config?.input_port as string) || 'texts';
  const outputPort = (data.config?.output_port as string) || 'embeddings';

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="processing"
      subtitle="Text → Vectors"
      selected={selected}
    >
      {/* Input handle with connection indicators */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id={inputPort}
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, inputPort))
            : undefined
        }
      />
      {/* Output handle */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id={outputPort}
        blockId={id}
      />
    </BaseNode>
  );
};
